import React, { useEffect, useRef, useState } from 'react';
import { Monitor, Moon, Sun } from 'lucide-react';
import { useTheme } from '../contexts/ThemeContext';

const THEME_OPTIONS = [
  {
    value: 'light',
    label: 'Svetlý režim',
    shortLabel: 'Svetlý',
    icon: Sun,
  },
  {
    value: 'dark',
    label: 'Tmavý režim',
    shortLabel: 'Tmavý',
    icon: Moon,
  },
  {
    value: 'system',
    label: 'Systémové nastavenie',
    shortLabel: 'Systém',
    icon: Monitor,
  },
];

const ThemeSwitcher = () => {
  const { theme, resolvedTheme, setTheme } = useTheme();
  const [open, setOpen] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('touchstart', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('touchstart', handleClickOutside);
    };
  }, []);

  const currentOption = THEME_OPTIONS.find((option) => option.value === theme) ?? THEME_OPTIONS[0];
  const ActiveIcon = theme === 'system'
    ? (resolvedTheme === 'dark' ? Moon : Sun)
    : currentOption.icon;

  const handleSelect = (value) => {
    setTheme(value);
    setOpen(false);
  };

  return (
    <div className="theme-switcher" ref={containerRef}>
      <button
        type="button"
        className="theme-button"
        onClick={() => setOpen((prev) => !prev)}
        aria-haspopup="listbox"
        aria-expanded={open}
      >
        <ActiveIcon size={16} />
        <span>{currentOption.shortLabel}</span>
      </button>

      {open && (
        <div className="theme-dropdown" role="listbox">
          {THEME_OPTIONS.map((option) => {
            const OptionIcon = option.icon;
            const isActive = theme === option.value;
            return (
              <button
                key={option.value}
                type="button"
                className={`theme-dropdown-item ${isActive ? 'active' : ''}`}
                onClick={() => handleSelect(option.value)}
                role="option"
                aria-selected={isActive}
              >
                <OptionIcon size={16} />
                <span className="theme-dropdown-label">{option.label}</span>
                {option.value === 'system' && (
                  <span className="theme-dropdown-hint">
                    Aktuálne: {resolvedTheme === 'dark' ? 'tmavý' : 'svetlý'}
                  </span>
                )}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default ThemeSwitcher;
